import React from "react";
import { AppointmentOverviewContext } from "../context/appointmentOverviewContext";
import Appointment from "../interface/appointment";
import SearchControllsProps from "../interface/searchControllsProps";
import FilterCheckbox from "../../../components/inputs/filterCheckbox/filterCheckbox";

const CheckBoxCompleted = (): React.JSX.Element => {
  const {
    searchControlls,
    setSearchControlls,
    appointments,
    setPaginationSettings,
  }: {
    searchControlls: SearchControllsProps;
    setSearchControlls: React.Dispatch<
      React.SetStateAction<SearchControllsProps>
    >;
    appointments: Appointment[] | null;
    setPaginationSettings: React.Dispatch<React.SetStateAction<any>>;
  } = React.useContext(AppointmentOverviewContext);

  const getCompletedCount = (): number => {
    return appointments
      ? appointments.filter(
          (appointment: Appointment) =>
            appointment.status === "G" &&
            new Date(appointment.date).toISOString().split("T")[0] <
              new Date().toISOString().split("T")[0]
        ).length
      : 0;
  };

  const onClickHandler = (): void => {
    setPaginationSettings((prev: any) => ({
      ...prev,
      page: 1,
    }));
    setSearchControlls((prev) => ({
      ...prev,
      status: {
        ...prev.status,
        completed: !prev.status.completed,
      },
    }));
  };

  return (
    <FilterCheckbox
      disabled={searchControlls.loading}
      badgeContent={getCompletedCount()}
      onClickHandler={onClickHandler}
      label="Beendet"
      checked={searchControlls.status.completed}
    />
  );
};

export default CheckBoxCompleted;
